import { Injectable } from '@angular/core';
import { FirebaseAuthDriver } from 'src/app/drivers/auth/firebase-auth.driver';
import { InternalApps } from 'src/app/global-components/apps/internal-apps';
import { AsyncHelper } from 'src/app/helpers/async.helper';
import { VfmService } from '../io/vfm.service';
import { LocalAppLauncher } from '../process/launchers/local-app-launcher';
import { IconsService } from '../ux/icons.service';
import { ThemeService } from '../ux/theme.service';
import { WindowsManagerService } from './windows-manager.service';

@Injectable({
  providedIn: 'root'
})
export class BootService {
  private boot = false;

  constructor(
    private themeSv: ThemeService,
    private vfm: VfmService,
    private windowSv: WindowsManagerService,
    private icons: IconsService) {
  }

  get hasBooted() {
    return this.boot;
  }

  async load(progressCb: Function) {
    const promises = [
      this.themeSv.loadTheme(),
      this.windowSv.waitForCompleteLoading(),
      this.icons.load(),
      this.vfm.load(),
      this.loadApps(),
      ...this.loadDrivers()
    ];

    for (let i = 0; i < promises.length; i++) {
      const p = promises[i];
      await p;

      progressCb((i + 1) / promises.length);
      await AsyncHelper.wait(100);
    }

    progressCb(1);
    await AsyncHelper.wait(500);

    this.boot = true;
  }

  private loadDrivers(): Promise<any>[] {
    return [
      FirebaseAuthDriver.load()
    ];
  }

  private loadApps() {
    InternalApps.forEach(internalApp => {
      LocalAppLauncher.registerApp("app://" + internalApp.name, internalApp.module, internalApp.assotiations);
    });
    return Promise.resolve(true);
  }
}
